import React from 'react';
import QRCode from 'qrcode.react';

const BillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '270px',
        marginTop: '5px', // Adjust the top margin as needed
        marginLeft: '0px',
        marginRight:'5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };


    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return num === 10 ? 'Ten' : teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    return (
        <div style={containerStyle}>
            {/* Render your label content using the fetched data */}
            {labelData && (
                <div>
                    <h2 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>{labelData.SalePrint.CompanyName}</h2>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '2px' }}>{labelData.SalePrint.CompanyAddress}</h5>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '2px' }}>{labelData.SalePrint.CompanyContactNo}</h5>
                    {labelData.SalePrint.BillRemarks && (
                        <h4 style={{ textAlign: 'center', marginTop: '0', marginBottom: '3px' }}>fssai Number :{labelData.SalePrint.BillRemarks}</h4>
                    )}

                    {labelData.SalePrint.GSTNumber && (
                        <h4 style={{ textAlign: 'center', marginTop: '0', marginBottom: '3px' }}>GST Number :{labelData.SalePrint.GSTNumber}</h4>
                    )}
                    <h3 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '2px' }}>SALE BILL</h3>
                </div>

            )}

            <table style={tableStyle}>

                <tr>
                    <td style={{ ...cellStyleN, width: '50%', textAlign: 'left' }} rowSpan={3}>
                        <h2 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0', marginBottom: '2px' }}>Table: {labelData.SalePrint.TableNmae}  </h2>
                    </td>
                    <td style={{ ...cellStyleN, width: '25%', textAlign: 'right', marginTop: '0', marginBottom: '0' }}>
                        <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0', marginBottom: '2px' }}>Bill No :</h1>
                    </td>
                    <td style={{ ...cellStyleN, width: '25%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                        <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0', marginBottom: '2px' }}>{labelData.SalePrint.InvoiceNumber} </h1>
                    </td>
                </tr>
                <tr>
                    <td style={{ ...cellStyleN, width: '75%', textAlign: 'right', marginTop: '0', marginBottom: '0' }}>
                        <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0', marginBottom: '2px' }}>Bill Date :</h1>
                    </td>
                    <td style={{ ...cellStyleN, width: '25%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                        <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0', marginBottom: '2px' }}>{new Date(labelData.SalePrint.InvoiceDate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        })} </h1>
                    </td>
                </tr>
                <tr>
                    <td style={{ ...cellStyleN, width: '75%', textAlign: 'right' }}>
                        <h3 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginBottom: '2px' }}> Time :</h3>
                    </td>
                    <td style={{ ...cellStyleN, width: '25%', textAlign: 'left' }}>
                        <h3 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginBottom: '2px' }}>{new Date(`2000-01-01T${labelData.SalePrint.InvoiceTime}`).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                        })} </h3>
                    </td>
                </tr>

            </table>



            {labelData && (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyle, width: '40%' }}>
                                <h4 style={{ marginTop: '4px', marginBottom: '2px' }}>Particular</h4>
                            </td>

                            <td style={{ ...cellStyle, width: '10%' }}>
                                <h4 style={{ marginTop: '5px', marginBottom: '2px' }}>Qty</h4>
                            </td>

                            <td style={{ ...cellStyle, width: '10%' }}>
                                <h4 style={{ marginTop: '5px', marginBottom: '2px' }}>Rate</h4>
                            </td>

                            <td style={{ ...cellStyle, width: '10%' }}>
                                <h4 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h4>
                            </td>

                        </tr>
                    </thead>
                    <tbody>
                        {labelData &&
                            labelData.SalePrintItems.map((record, index) => (
                                <tr key={index} style={{ height: '40px' }}>

                                    {/* <td style={{ ...cellStyle, width: '40%', height: '40px', textAlign: 'left' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '15px', textAlign: 'left',marginLeft:'5px',wordWrap: 'break-word',whiteSpace: 'normal'  }}>
                                            {record.ItemName}
                                        </label>
                                    </td> */}

                                    <td style={{ ...cellStyle, width: '40%', height: '40px', textAlign: 'left' }}>
                                        <div style={{ marginLeft: '5px' }}>
                                            <label style={{
                                                marginTop: '5px',
                                                fontFamily: 'Arial',
                                                fontSize: '15px',
                                                textAlign: 'left',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'normal'
                                            }}>
                                                {record.ItemName}
                                            </label>
                                        </div>
                                    </td>


                                    <td style={{ ...cellStyle, width: '10%', height: '40px', textAlign: 'right' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '15px', marginRight: '5px' }}>
                                            {record.Quantity}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '10%', height: '40px', textAlign: 'right' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '15px', marginRight: '5px' }}>
                                            {record.Rate}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '10%', height: '40px', textAlign: 'right' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '15px', marginRight: '5px' }}>
                                            {record.Amount}
                                        </label>
                                    </td>

                                </tr>
                            ))}
                    </tbody>
                </table>
            )}
            {labelData && (
                <table style={tableStyle}>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '3px', marginBottom: '1px' }}>Total</h1>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '3px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.Amount).toFixed(2)}</h1>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>Discount</h1>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.DiscountAmount).toFixed(2)}</h1>
                        </td>
                    </tr>


                    {labelData.SalePrint.GSTNumber && (
                        <tr>
                            <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>CGST</h1>
                            </td>
                            <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.CGSTAmount).toFixed(2)}</h1>
                            </td>
                        </tr>

                    )}

                    {labelData.SalePrint.GSTNumber && (
                        <tr>
                            <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>SGST</h1>
                            </td>
                            <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.SGSTAmount).toFixed(2)}</h1>
                            </td>
                        </tr>

                    )}

                    {labelData.SalePrint.PackingCharge > 0 && (
                        <tr>
                            <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>Packing Charge</h1>
                            </td>
                            <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                                <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.PackingCharge).toFixed(2)}</h1>
                            </td>
                        </tr>

                    )}

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>Round Off</h1>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.RoundOff).toFixed(2)}</h1>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>Grand Total</h1>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h1 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '1px', marginBottom: '1px' }}>{parseFloat(labelData.SalePrint.TotalAmount).toFixed(2)}</h1>
                        </td>

                    </tr>
                </table>
            )}
            <hr style={{ marginTop: '0' }} />

            {labelData && (

                <h4 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={labelData.SalePrint.TotalAmount} /></h4>
            )}


            {/* QR Code Section */}
            {labelData && labelData.SalePrint.paymentqr !== null && labelData.SalePrint.paymentqr !== "" && (
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <QRCode value={labelData.SalePrint.paymentqr} size={110} />
                </div>
            )}

            {labelData && (
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <h4 style={{ marginBottom: '2px' }}>THANK YOU. VISIT AGAIN</h4>
                </div>
            )}

            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 1px;
                        }
                    }
                `}
            </style>

        </div>
    );
};

export default BillPrint;
